<!-- Accordion -->
<p-accordion [activeIndex]="[0, 1, 2]"
             [multiple]="true"
             styleClass="no_border"
             class="w-full h-full ml-3 mr-3">
  <p-accordionTab [header]="'global.general' | translate"
                  headerStyleClass="uppercase">
    <div class="flex flex-column align-items-center">
      <!-- Name -->
      <medsurf-slide-edit-shared-name-form [class]="'w-full'"></medsurf-slide-edit-shared-name-form>
      
      <!-- Type -->
      <medsurf-slide-edit-free-form-type-form [class]="'w-full'"></medsurf-slide-edit-free-form-type-form>
      
      <!-- Link -->
      <medsurf-slide-edit-shared-link-form [class]="'w-full'"></medsurf-slide-edit-shared-link-form>
    </div>
  </p-accordionTab>
  <p-accordionTab [header]="'global.layout' | translate"
                  headerStyleClass="uppercase">
    <div class="flex flex-column align-items-center">
      <!-- Line Layout -->
      <medsurf-slide-edit-free-form-line-form [class]="'w-full'"></medsurf-slide-edit-free-form-line-form>
      
      <!-- Pointer Layout -->
      <medsurf-slide-edit-free-form-pointer-form [class]="'w-full'"></medsurf-slide-edit-free-form-pointer-form>
      
      <!-- Line Style Layout -->
      <medsurf-slide-edit-free-form-line-style-form [class]="'w-full'"></medsurf-slide-edit-free-form-line-style-form>
    </div>
  </p-accordionTab>
  <p-accordionTab [header]="'global.relation' | translate"
                  headerStyleClass="uppercase">
    <div class="flex flex-column align-items-center">
      <!-- Images -->
      <medsurf-slide-edit-shared-image-form [class]="'w-full'"></medsurf-slide-edit-shared-image-form>
      
      <!-- POIs -->
      <medsurf-slide-edit-shared-poi-form [class]="'w-full'"></medsurf-slide-edit-shared-poi-form>
      
      <!-- Groups -->
      <medsurf-slide-edit-shared-group-form [class]="'w-full'"></medsurf-slide-edit-shared-group-form>
    </div>
  </p-accordionTab>
</p-accordion>
